import React from "react";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Grid from "material-ui/Grid";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Drawer from "material-ui/Drawer";

class Content extends React.Component {
  state = {
    right: false
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  render() {
    const {
      classes,
      translate,
      children,
      open,
      ctx,
      toggle,
      drawerTitle,
      isSubTestView
    } = this.props;
    return (
      <div className={classes.wrapper}>
        <div className={isSubTestView ? classes.centred2 : classes.centred}>
          <div className={classes.content}>
            <Grid container spacing={24} className={classes.root}>
              <Grid item xs={12}>
                {children}
              </Grid>
            </Grid>
            <Drawer
              anchor="right"
              open={open}
              className={classes.contextMenu}
              onClose={() => toggle()}
            >
              <AppBar position="static">
                <Toolbar>
                  <Typography
                    type="title"
                    className={classes.flex}
                    color={"inherit"}
                  >
                    {drawerTitle
                      ? translate(drawerTitle)
                      : translate("select_columns")}
                  </Typography>
                  <Button onClick={() => toggle()} fab mini color={"accent"}>
                    <Icon>close</Icon>
                  </Button>
                </Toolbar>
              </AppBar>
              <Grid container spacing={24} className={classes.root}>
                <Grid item>{ctx}</Grid>
              </Grid>
            </Drawer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Content);



// WEBPACK FOOTER //
// ./src/components/ui/content/index.js